import { useNavigate } from 'react-router-dom';

const Video = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    console.log('Navigating...'); 
    navigate('/'); 
  };

  const latestStories = [
    {
      title: "How to Safely Trim Your Cat's Nails Without Injuring Them",
      image: "https://d1m34p9xkycorf.cloudfront.net/How_to_Safely_Trim_Your_Cat_s_Nails.jpg",
    },
    {
      title: "Basic Training Techniques for New Puppy Owners",
      image: "https://d1m34p9xkycorf.cloudfront.net/Basic_Training_Techniques_for_New_Puppy_Owners.png",
    },
    {
      title: "Secret Language of Cats - Cat Tail Movements",
      image: "https://d1m34p9xkycorf.cloudfront.net/cat_tail_movements.jpg",
    },
    {
      title: "Role of Pets in Community and Social Life",
      image: "https://d1m34p9xkycorf.cloudfront.net/commmwofit.jpg",
    },
    {
      title: "Rising Trend of Pet Wellness and Spa Services",
      image: "https://d1m34p9xkycorf.cloudfront.net/rtphwofit.jpg",
    },
    {
      title: "Safe Mating for Dogs and Cats - A Guide for Pet Owners",
      image: "https://d1m34p9xkycorf.cloudfront.net/smfdgwofit.jpg",
    },
  ];

  return (
    <div className="p-4">
      <div className="md:flex mt-14 flex-col md:flex-row items-center">
        <iframe
          className="md:ml-20 w-full md:w-[560px] h-[315px]"
          src="https://www.youtube.com/embed/SMpOcYcmIl8?si=NlWc6dEGi3xJuyIu&autoplay=1&mute=1"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>

        <div className="text-center md:text-left mt-6 md:mt-0">
          <p className="text-2xl md:text-4xl font-extrabold mt-4 md:ml-36 md:mt-[100px]">
            Adopt a Pet Explained in 30 seconds
          </p>
          <button
            onClick={handleNavigation}
            className="bg-orange-600 w-full md:w-[300px] md:ml-44 h-[60px] font-bold text-white rounded-lg mt-4 md:mt-20"
          >
            Book a Service
          </button>
        </div>
      </div>

      <div className="latest-stories p-8 mt-14">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          Latest Stories from Adopt A Pet
        </h2>
        <div className="stories-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestStories.map((story, index) => (
            <div
              key={index}
              className="story-card border p-4 rounded-lg shadow-md hover:shadow-lg transition-all"
            >
              <img
                src={story.image}
                alt={story.title}
                className="w-full h-52 object-cover rounded-t-lg mb-4"
              />
              <h3 className="text-lg sm:text-xl font-semibold">{story.title}</h3>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-6">
          <button className="bg-orange-600 w-[200px] h-[60px] font-bold text-white rounded-xl">
            Read Blog
          </button>
        </div>
      </div>
    </div>
  );
};

export default Video;
